import React from 'react';
import Loadable from 'react-loadable';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../../components/loading_spinner/loading_spinner')
);

let Ibd2019Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Ibd2019Component = require('../../tag_page/tag_page').default;
}

export function ibd2019Page(store) {
  const routeConfig = {
    path: '/innovation-by-design/2019',
    component() {
      if (Ibd2019Component) {
        return <Ibd2019Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Ibd2019Component ? Ibd2019Component.loadData(store) : false,
    preloadChunk() {
      return import('../../tag_page/tag_page').then(resp => {
        Ibd2019Component = resp.default;
        routeConfig.loadData = Ibd2019Component.loadData(store);
        return Ibd2019Component;
      });
    },
    chunk: 'ibdPage',
    autoScrollOff: true
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('./innovation_by_design_page_2018').default;
}

export function ibd2018Page(store) {
  const routeConfig = {
    path: '/innovation-by-design/2018',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "ibdPage" */ './innovation_by_design_page_2018').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store);
          return Component;
        }
      );
    },
    chunk: 'ibdPage',
    autoScrollOff: true
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let LegacyComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  LegacyComponent = require('./innovation_by_design_page').default;
}

export function legacyIbdPage(store) {
  const routeConfig = {
    path: '/innovation-by-design/:year(2012|2013|2014|2015|2016|2017)',
    component() {
      if (LegacyComponent) {
        return <LegacyComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: LegacyComponent ? LegacyComponent.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "legacyIbdPage" */ './innovation_by_design_page').then(
        resp => {
          LegacyComponent = resp.default;
          routeConfig.loadData = LegacyComponent.loadData(store);
          return LegacyComponent;
        }
      );
    },
    chunk: 'legacyIbdPage',
    autoScrollOff: true
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

let DefaultComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  DefaultComponent = require('./innovation_by_design_page_controller').default;
}

export function defaultIbdPage(store) {
  const routeConfig = {
    path: '/innovation-by-design/:year',
    component() {
      if (DefaultComponent) {
        return <DefaultComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: DefaultComponent ? DefaultComponent.loadData(store) : false,
    preloadChunk() {
      return import('./innovation_by_design_page_controller').then(resp => {
        DefaultComponent = resp.default;
        routeConfig.loadData = DefaultComponent.loadData(store);
        return DefaultComponent;
      });
    },
    chunk: 'defaultMcpPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

// ======================================

let AnniversaryComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  AnniversaryComponent = require('./innovation_by_design_anniversary_page')
    .default;
}

export function anniversaryIbdPage(store) {
  const routeConfig = {
    path: '/innovation-by-design/:year/:subpage',
    component() {
      if (AnniversaryComponent) {
        return <AnniversaryComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: AnniversaryComponent
      ? AnniversaryComponent.loadData(store)
      : false,
    preloadChunk() {
      return import('./innovation_by_design_anniversary_page').then(resp => {
        AnniversaryComponent = resp.default;
        routeConfig.loadData = AnniversaryComponent.loadData(store);
        return AnniversaryComponent;
      });
    },
    chunk: 'defaultMcpPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
